import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';

import MIcon from 'views/MIcon/MIcon';

import { DatePickerFormats } from 'utils/enums/time-format';
import classes from './MDatetimePicker.module.scss';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import useLocaleState from 'utils/hooks/use-locale-state';
import { VscClose } from 'react-icons/vsc';

type Props = {
  value?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  selectsEnd?: boolean;
  showTimeSelect?: boolean;
  dateFormat?: DatePickerFormats;
  showNavigator?: boolean;
  disabled?: boolean;
  className?: string;
  timeFormat?: DatePickerFormats;
  valid?: boolean;
  invalid?: boolean;
  name?: string;
  placeholder?: string;
  showTimeSelectOnly?: boolean;
  timeIntervals?: number;
  minDate?: Date;
  maxDate?: Date;
  selected?: Date | null;
  selectsStart?: boolean;
  datePickerRef: React.RefObject<ReactDatePicker>;
  showResetDate?: boolean;
  clearButton?: boolean;
  showYearDropdown?: boolean;
  currentDate: Date;
  onClickClearBtn: () => void;
  onClickResetDate?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onLeftNavigatorClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onRightNavigatorClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onChange: (date: Date | null) => void;
};

const MDatetimePickerView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [localeState] = useLocaleState();

  return (
    <div className={classes['container']}>
      {props.showNavigator ? (
        <button
          className={`${classes['navigator']} ${props.disabled ? classes['navigator--disabled'] : ''}`.trim()}
          disabled={props.disabled}
          onClick={props.onLeftNavigatorClick}
        >
          <MIcon name={IoChevronBack}></MIcon>
        </button>
      ) : null}
      <div className={classes['picker']}>
        <ReactDatePicker
          showYearDropdown={props.showYearDropdown}
          ref={props.datePickerRef}
          startDate={props.startDate}
          selectsEnd={props.selectsEnd}
          endDate={props.endDate}
          popperClassName={classes['popper']}
          className={`${classes['field']} ${props.className || ''}  ${props.disabled ? classes['field--disabled'] : ''} ${
            props.invalid ? classes['field--invalid'] : ''
          }`.trim()}
          autoComplete="off"
          name={props.name}
          placeholderText={props.placeholder}
          showTimeSelect={props.showTimeSelect}
          showTimeSelectOnly={props.showTimeSelectOnly}
          wrapperClassName="w-100"
          selected={props.selected || props.value}
          timeFormat={DatePickerFormats.Time}
          onChange={props.onChange}
          minDate={props.minDate}
          maxDate={props.maxDate}
          timeIntervals={props.timeIntervals}
          dateFormat={props.dateFormat || DatePickerFormats.MonthDayYear}
          disabled={props.disabled}
          locale={localeState}
        ></ReactDatePicker>
        {props.clearButton && props.value ? (
          <button type="button" className={classes['clear']} onClick={props.onClickClearBtn}>
            <MIcon name={VscClose}></MIcon>
          </button>
        ) : null}
        {props.showResetDate && props.value?.getDate() !== props.currentDate.getDate() ? (
          <button
            type="button"
            className={classNames(classes['resetDate'], { [classes['resetDate--withClear']]: props.clearButton && props.value })}
            onClick={props.onClickResetDate}
          >
            <MIcon className={classes['resetDate__icon']} name="resetDate"></MIcon>
          </button>
        ) : null}
      </div>
      {props.showNavigator ? (
        <button
          className={`${classes['navigator']} ${props.disabled ? classes['navigator--disabled'] : ''}`.trim()}
          disabled={props.disabled}
          onClick={props.onRightNavigatorClick}
        >
          <MIcon name={IoChevronForward}></MIcon>
        </button>
      ) : null}
    </div>
  );
};

MDatetimePickerView.displayName = 'MDatetimePickerView';

export default MDatetimePickerView;
